import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Music } from 'lucide-react';

/**
 * Reusable page header for static pages (FAQ, About, Contact, etc.)
 * Updated: Links now point to / which serves the static landing.html
 */
export const PageHeader = ({ showBack = true }) => {
  return (
    <div className="border-b border-gray-200 bg-white sticky top-0 z-50 shadow-sm">
      <div className="max-w-5xl mx-auto px-6 py-4 flex items-center justify-between">
        {showBack ? (
          <a
            href="/"
            className="flex items-center gap-2 text-gray-600 hover:text-violet-600 transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
            <span className="hidden sm:inline">Retour à l&apos;accueil</span>
          </a>
        ) : (
          <div />
        )}
        <a href="/" className="flex items-center gap-3">
          <div className="w-10 h-10 bg-gradient-to-br from-violet-600 to-purple-600 rounded-xl flex items-center justify-center shadow-md">
            <Music className="w-5 h-5 text-white" />
          </div>
          <span className="text-gray-900 font-bold text-lg">DJ Nomad</span>
        </a>
      </div>
    </div>
  );
};

/**
 * Hero section for static pages
 */
export const PageHero = ({ icon: Icon, title, subtitle }) => {
  return (
    <div className="bg-gradient-to-br from-violet-600 via-purple-600 to-violet-700 py-16">
      <div className="max-w-5xl mx-auto px-6 text-center">
        {Icon && (
          <div className="inline-flex items-center justify-center w-16 h-16 bg-white/20 backdrop-blur-sm rounded-2xl mb-6">
            <Icon className="w-8 h-8 text-white" />
          </div>
        )}
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">{title}</h1>
        {subtitle && <p className="text-xl text-white/80">{subtitle}</p>}
      </div>
    </div>
  );
};

/**
 * Reusable footer for static pages
 */
export const PageFooter = () => {
  return (
    <footer className="bg-gray-900 text-white py-8 mt-auto">
      <div className="max-w-5xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <a href="/" className="flex items-center gap-3">
            <div className="w-8 h-8 bg-gradient-to-br from-violet-600 to-purple-600 rounded-lg flex items-center justify-center">
              <Music className="w-4 h-4 text-white" />
            </div>
            <span className="font-semibold">DJ Nomad</span>
          </a>
          <div className="flex flex-wrap gap-6 text-sm text-gray-400">
            <Link to="/faq" className="hover:text-violet-400 transition-colors">FAQ</Link>
            <Link to="/about" className="hover:text-violet-400 transition-colors">À propos</Link>
            <Link to="/contact" className="hover:text-violet-400 transition-colors">Contact</Link>
            <Link to="/blog" className="hover:text-violet-400 transition-colors">Blog</Link>
            <Link to="/terms" className="hover:text-violet-400 transition-colors">CGU</Link>
            <Link to="/privacy" className="hover:text-violet-400 transition-colors">Confidentialité</Link>
          </div>
          <p className="text-gray-500 text-sm">© 2025 DJ Nomad</p>
        </div>
      </div>
    </footer>
  );
};

/**
 * Page layout wrapper
 */
const PageLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {children}
    </div>
  );
};

export default PageLayout;
